import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["customTag", "dataTestId", "draggable"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getRem, wordBreak } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCardWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  min-width: 0;\n  ", "\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.color.additional.light.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getRem(theme.size.borderRadius.large.value);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.elevation[1].value;
}, wordBreak, function (_ref4) {
  var draggable = _ref4.draggable,
      theme = _ref4.theme;
  return draggable && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      cursor: move;\n\n      &:active {\n        box-shadow: ", ";\n      }\n    "])), theme.elevation[4].value);
});

var CardWrapper = function CardWrapper(_ref5) {
  var customTag = _ref5.customTag,
      dataTestId = _ref5.dataTestId,
      draggable = _ref5.draggable,
      other = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(StyledCardWrapper, _objectSpread({
    "data-testid": dataTestId ? "".concat(dataTestId, "-wrapper") : undefined,
    as: customTag,
    draggable: draggable
  }, other));
};

CardWrapper.displayName = "CardWrapper";
CardWrapper.propTypes = {
  /** Ability to supply a different element instead of the default one */
  customTag: PropTypes.elementType,

  /** If true, makes component draggable */
  draggable: PropTypes.bool,

  /** ID for testing the node */
  dataTestId: PropTypes.string
};
CardWrapper.defaultProps = {
  customTag: undefined,
  draggable: false,
  dataTestId: ''
};
export { CardWrapper };